/**
 * @generated SignedSource<<990ab50a0171b9465954e4bd90c9833d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useMeetingRecordingWebsocketClipsRefetchQuery$variables = {
  recordingId: string;
};
export type useMeetingRecordingWebsocketClipsRefetchQuery$data = {
  readonly meetingRecording: {
    readonly __typename: "MeetingRecording";
    readonly clips: ReadonlyArray<{
      readonly clipEnd: number;
      readonly clipStart: number;
      readonly id: string;
      readonly " $fragmentSpreads": FragmentRefs<"ClipsPanel_ClipSummary_clip">;
    }> | null;
    readonly " $fragmentSpreads": FragmentRefs<"ClipsPanel_meetingRecording">;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  } | null;
};
export type useMeetingRecordingWebsocketClipsRefetchQuery = {
  response: useMeetingRecordingWebsocketClipsRefetchQuery$data;
  variables: useMeetingRecordingWebsocketClipsRefetchQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "recordingId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "recordingId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "clipStart",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "clipEnd",
  "storageKey": null
},
v6 = [
  (v3/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "fullName",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useMeetingRecordingWebsocketClipsRefetchQuery",
    "selections": [
      {
        "alias": "meetingRecording",
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "MeetingRecordingClip",
                "kind": "LinkedField",
                "name": "clips",
                "plural": true,
                "selections": [
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/),
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "ClipsPanel_ClipSummary_clip"
                  }
                ],
                "storageKey": null
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "ClipsPanel_meetingRecording"
              }
            ],
            "type": "MeetingRecording",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useMeetingRecordingWebsocketClipsRefetchQuery",
    "selections": [
      {
        "alias": "meetingRecording",
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "MeetingRecordingClip",
                "kind": "LinkedField",
                "name": "clips",
                "plural": true,
                "selections": [
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "title",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "meetingRecordedVideoDuration",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "summary",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "viewerCanEdit",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "meetingRecordedVideoPosterUrl",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "meetingRecordedVideoUrl",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isFavourite",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "creator",
                    "plural": false,
                    "selections": (v6/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "lastEditedBy",
                    "plural": false,
                    "selections": (v6/*: any*/),
                    "storageKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v2/*: any*/)
                    ],
                    "type": "MeetingRecordingInterface",
                    "abstractKey": "__isMeetingRecordingInterface"
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "MeetingRecording",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "cb745736bfa736af6a47bf55004485c2",
    "id": null,
    "metadata": {},
    "name": "useMeetingRecordingWebsocketClipsRefetchQuery",
    "operationKind": "query",
    "text": "query useMeetingRecordingWebsocketClipsRefetchQuery(\n  $recordingId: ID!\n) {\n  meetingRecording: node(id: $recordingId) {\n    __typename\n    ... on MeetingRecording {\n      clips {\n        id\n        clipStart\n        clipEnd\n        ...ClipsPanel_ClipSummary_clip\n      }\n      ...ClipsPanel_meetingRecording\n    }\n    id\n  }\n}\n\nfragment ClipsPanel_ClipCard_clip on MeetingRecordingClip {\n  id\n  title\n  viewerCanEdit\n  meetingRecordedVideoDuration\n  meetingRecordedVideoPosterUrl\n  meetingRecordedVideoUrl\n  summary\n  isFavourite\n  creator {\n    id\n    fullName\n  }\n  lastEditedBy {\n    id\n    fullName\n  }\n  ...utils_useGetURL_recording\n  ...ClipsPanel_RenameClipModal_clip\n  ...ClipsPanel_DeleteClipModal_clip\n}\n\nfragment ClipsPanel_ClipSummary_clip on MeetingRecordingClip {\n  id\n  title\n  meetingRecordedVideoDuration\n  summary\n}\n\nfragment ClipsPanel_DeleteClipModal_clip on MeetingRecordingClip {\n  id\n  title\n}\n\nfragment ClipsPanel_RenameClipModal_clip on MeetingRecordingClip {\n  id\n  title\n}\n\nfragment ClipsPanel_meetingRecording on MeetingRecording {\n  id\n  clips {\n    id\n    ...ClipsPanel_ClipCard_clip\n  }\n}\n\nfragment utils_useGetURL_recording on MeetingRecordingInterface {\n  __isMeetingRecordingInterface: __typename\n  __typename\n  ... on MeetingRecording {\n    id\n  }\n  ... on MeetingRecordingClip {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "83aeed13e98689b8f8fceecad40c9358";

export default node;
